<template>
  <div>
    <list
      ref="list"
      @create="create()"
      @update="update()"
      @remove="remove()"
      :filter-stadium="filterStadium"
    />
    <form-manager
      @close="close()"
      :modal="modal"
      :external-action="action"
      :Edit="edit"
      :external-pitch="complexAula"
      :stadium-id="centro._id"
    ></form-manager>
  </div>
</template>

<script>
import list from './list'
import formManager from './formManager'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'pitches',
  components: {
    list,
    formManager
  },
  props: {
    filterStadium: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modal: false,
      action: 'create',
      edit: true
    }
  },
  mounted() {
    // this.initData()
  },
  computed: {
    ...mapState({
      aula: state => state.pitches.pitchSelected,
      centro: state => state.stadiums.stadiumSelected,
      statusOfButton: state => state.events.status
    }),
    complexAula() {
      let result = this.aula
      result.centroId = this.centro
      return result
    }
  },
  methods: {
    ...mapActions({
      init: 'pitches/setInit',
      setStatus: 'events/setStatus',
      getOne: 'stadiums/setOne'
    }),
    close() {
      this.modal = false
      this.nextTick(_ => {
        this.action = ''
        this.$refs.list.status = false
        let me = this
        setTimeout(function() {
          me.getOne(me.centro._id)
        }, 2000)
      })
    },
    create() {
      this.action = 'create'
      this.edit = true
      this.nextTick(_ => {
        this.modal = true
      })
    },
    update() {
      this.action = 'update'
      this.edit = true
      this.nextTick(_ => {
        this.modal = true
      })
    },
    remove() {
      this.action = 'remove'
      this.edit = false
      this.nextTick(_ => {
        this.modal = true
      })
    }
  }
}
</script>
